// extracted by mini-css-extract-plugin
module.exports = {"hitsContainer":"SearchHits_hitsContainer__YxW6y"};